import React from 'react';
import {
  FormControl,
  InputLabel,
  TextField,
  Grid,
  GridProps,
} from '@mui/material';
import { FORM_STYLES } from '../../../constants';
import { handleKeyDown, handleNumberMaxLength, handlePaste } from '../../../helpers';

export interface FormFieldProps {
  id: string;
  label: string;
  value?: string | number |null;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  type?: 'text' | 'number' | 'email';
  maxLength?: number;
  gridProps?: GridProps;
  multiline?: boolean;
  rows?: number;
  error?: boolean;
  helperText?: string;
}

const FormField: React.FC<FormFieldProps> = ({
  id,
  label,
  value = '',
  onChange,
  onBlur,
  placeholder,
  required = false,
  disabled = false,
  type = 'text',
  maxLength,
  gridProps = { md: 3, xs: 12 },
  multiline = false,
  rows,
  error = false,
  helperText,
}) => {
  return (
    <Grid item {...gridProps}>
      <FormControl fullWidth size={FORM_STYLES.FIELD_SIZE}>
        <InputLabel
          style={FORM_STYLES.LABEL}
          shrink={true}
          id={`${id}Label`}
          htmlFor={id}
        >
          {label}
          {required ? <sup>*</sup> : <sup>&nbsp;</sup>}
        </InputLabel>
        <TextField
          autoComplete="off"
          id={id}
          data-testid={id}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          variant="outlined"
          name={id}
          type={type}
          disabled={disabled}
          multiline={multiline}
          rows={rows}
          error={error}
          title={(value?.toString()?.length ?? 0) > 30 ? value?.toString() : undefined}
          helperText={helperText}
          FormHelperTextProps={{
            'data-testid': helperText ? `${id}-error` : undefined,
          } as any}
          inputProps={{
            maxLength,
            style: FORM_STYLES.INPUT,
            'aria-labelledby': `${id}Label`,
          }}
          {...(type === 'number' && {
            onPaste: handlePaste,
            onKeyDown: handleKeyDown,
            onInput: (e: React.ChangeEvent<HTMLInputElement>) => {
              handleNumberMaxLength(e, maxLength);
            }
          })}
        />
      </FormControl>
    </Grid>
  );
};

export default FormField;